import DiscountReasonListViewModel from "../view/discountreasonlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedDiscountReasons extends PagedElements<DiscountReasonListViewModel> {
    constructor(init?: Partial<PagedDiscountReasons>) { super(init); }
}